import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/auth/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e2) {
      setError(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell heading="Reset password" sub="We'll email you a secure reset link.">
      {done ? (
        <div className="space-y-6" data-testid="forgot-success">
          <p className="text-sm text-slate-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2">
            If an account exists for that email, a reset link has been sent. It expires in 1 hour.
          </p>
          <Link to="/login" data-testid="back-to-login-link" className="text-sm text-[#002FA7] hover:underline">
            Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          {error && (
            <div data-testid="forgot-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
              {error}
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="fp-email">Email</Label>
            <Input id="fp-email" data-testid="forgot-email-input" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <Button type="submit" data-testid="forgot-submit-btn" disabled={loading}
            className="w-full bg-slate-950 hover:bg-slate-800 text-white">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
          <div className="text-right">
            <Link to="/login" className="text-sm text-[#002FA7] hover:underline">Back to sign in</Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
